<script>
  import {
    brandMethods,
  } from '@state/helpers'

  export default {
    props: {
      type: {
        type: String,
        default: null,
      },
      collapse: {
        type: Boolean,
        default: false,
      },
      hasStock: {
        type: Boolean,
        default: false,
      },
      hasProduct: {
        type: Boolean,
        default: false,
      },
      bySupplierId: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        brands: [],
        boundCollapse: false,
      }
    },
    computed:{
      brandFilter(){
        return this.brands.map(el => {
          if (el.selected){
            return el.id
          }
        }).filter(el => el)
      }
    },
    watch: {
      brandFilter (val) {
        this.$emit('filter', {
          brand_ids: val,
        })
      },
    },
    async created() {
      this.boundCollapse = Boolean(this.collapse)
      this.boundCollapse = !this.boundCollapse
      return this.loadData()
    },
    methods: {
      ...brandMethods,
      async loadData () {
        const params = {
          fields: 'id, name',
          limit: 500,
          type: this.type,
          orderBy: 'name',
          sortedBy: 'asc',
        }
        if (this.hasStock) {
          params.has_stock = 1
        }
        if (this.hasProduct) {
          params.has_product = 1
        }
        if (this.bySupplierId) {
          params.supplier_id = this.bySupplierId
        }
        const { data } = await this.getListBrands(params)
        const brands = data.data
        brands.forEach(el => el.selected = false)
        this.brands = brands
      },
    },
  }
</script>

<template>
  <div v-bind="$attrs" class="block-item">
    <div class="block-heading">
      <h3
        v-fabric-collapse.accordion-brand
        class="
          tw-flex tw-items-center
          tw-text-positive
          tw-leading-relaxed tw-font-medium tw-text-base">
        <a class="tw-no-underline" href="javascript:">Filter by brand</a>
        <BaseChevronRotate
          transition-class="rotate-360-270"
          :toggle="!boundCollapse"
          :duration="500"
          :default-collapsed="collapse"
        />
      </h3>
      <FabricBadge
        :styling-bg="brandFilter.length ? 'badge-primary' : 'badge-light'"
        :copy="brandFilter.length"
      />
    </div>
    <FabricCollapse
      id="accordion-brand"
      v-model="boundCollapse"
      hide-header
      :duration="500"
      :default-shown="!collapse">
      <div
        class="block-content"
        :class="{ 'ovf-y-scroll scroll-primary mg-r-5 pd-t-u mg-t-10 mx-h-300': (brands && brands.length > 8) }">
        <FabricCheckbox
          v-for="brand in brands"
          :key="brand.id"
          v-model="brand.selected"
          :value="brand.id"
          slot-classes="tw-pl-3 tw-text-black"
        >{{ brand.name }}</FabricCheckbox>
      </div>
    </FabricCollapse>
  </div>
</template>
